require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-grass-fed-meat.json") })
        }
      }, "path---post-grass-fed-meat");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-grass-fed-meat!./.cache/json/post-grass-fed-meat.json
// module id = 352
// module chunks = 231608221292675